import { z } from 'zod'

const subYears = (date: Date, years: number) => {
  const value = new Date(date)
  value.setFullYear(value.getFullYear() - years)
  return value
}

const over18Date = subYears(new Date(), 18)

export const BirthdateValues = {
  min: new Date('1900-01-01'),
  over18: over18Date,
  max: over18Date,
  default: new Date('1980-01-01'),
} as const

export const BirthdateSchema = z.coerce
  .date({
    error: (issue) => {
      if (issue.code === 'invalid_type') {
        return 'required'
      }
    },
  })
  .max(BirthdateValues.over18, 'birthday.max')
  .min(BirthdateValues.min, 'birthday.min')

export const InvoiceBirthdateSchema = z.coerce
  .date({
    error: (issue) => {
      if (issue.code === 'invalid_type') {
        return 'required'
      }
    },
  })
  .max(BirthdateValues.over18, 'birthday.max')
  .min(BirthdateValues.min, 'birthday.min')
